export interface Address {
    address: string;
    mapType?: 'YANDEX' | 'GOOGLE';
    lang: 'ru' | 'en';
}

export interface AddressInfo {
    location: {
        lat: number;
        lng: number;
    };
    formattedAddress: string;
    nativeStringAddress: string;
    addressComponents: [
        {
            kind: string;
            name: string;
            types: [string];
        },
    ];
}

export interface AddressExtend {
    id?: number;
    gps: string;
    address: string;
    country: string | null;
    city: string | null;
}

export const clusterEvents = [
    'ObjectEvent',
    'AggregationEvent',
    'TransactionEvent',
    'TransformationEvent',
    'AssociationEvent',
] as const;

export type ClusterEventType = typeof clusterEvents[number];

export interface ClustersRequest {
    bounds: string;
    zoomLevel: number;
    eventTypes?: string;
    startDate?: string;
    endDate?: string;
}

export interface Cluster {
    clusterId: string;
    centerLatitude: number;
    centerLongitude: number;
    eventsCount: number;
    eventTypes: ClusterEventType[];
    lastEventTime: string;
    radius: number;
}
